import { INITIAL_PARENT_ADDRESS } from "@/contract/constants";
import { fetchFriendship } from "@/contract/funding/read";

const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";

export function resolveParentFromUrl() {
  try {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref && /^0x[a-fA-F0-9]{40}$/.test(ref)) {
      return ref;
    }
  } catch {
    /* ignore */
  }
  return INITIAL_PARENT_ADDRESS;
}

/** 认购弹窗展示的有效上级：已绑定则链上上级，否则为本次将绑定的 parent */
export async function resolveEffectiveUplineAddress(accountAddress) {
  if (accountAddress) {
    const bound = await fetchFriendship(accountAddress);
    if (
      bound &&
      /^0x[a-fA-F0-9]{40}$/.test(bound) &&
      bound.toLowerCase() !== ZERO_ADDRESS
    ) {
      return bound;
    }
  }
  return resolveParentFromUrl();
}
